<script setup lang="ts">
  import { watch } from 'vue';
  import { useRoute, useRouter, type RouteLocationRaw } from 'vue-router';
  import { InviteBackground } from '@/features/invite';
  import { AuthManager, useAuth } from '@/entities/auth';
  import { useVerifyUserMutation } from '@/entities/wallets';
  import { useUser } from '@/entities/user';
  import { HOME } from '@/common';

  const route = useRoute();
  const router = useRouter();
  const { updateAuthManager } = useAuth();
  const { isLoggedIn } = useUser();
  const { mutateAsync: verifyUser } = useVerifyUserMutation();

  const getRedirectUrl = () =>
    typeof route.query.redirectUrl === 'string'
      ? route.query.redirectUrl
      : undefined;

  const resolveFormType = () => {
    const typeParam =
      typeof route.query.type === 'string' ? route.query.type : undefined;
    const modeParam =
      typeof route.query.mode === 'string' ? route.query.mode : undefined;
    const normalized = (typeParam ?? modeParam)?.toLowerCase();

    return normalized === 'signup' ? 'signup' : 'login';
  };

  const redirectIfLoggedIn = async () => {
    const redirectUrl = getRedirectUrl();
    await verifyUser();
    if (redirectUrl) {
      if (redirectUrl.startsWith('http')) {
        window.location.assign(redirectUrl);
      } else {
        router.replace(redirectUrl as RouteLocationRaw);
      }
    } else {
      router.replace({ name: HOME });
    }
  };

  watch(
    isLoggedIn,
    async (loggedIn) => {
      if (loggedIn) {
        await verifyUser();
        console.log('redirecting if logged in');
        redirectIfLoggedIn();
        return;
      }
      updateAuthManager('callback', {
        name: 'login-signup',
        type: resolveFormType(),
      });
    },
    { immediate: true },
  );
</script>

<template>
  <div class="h-screen">
    <invite-background />
    <div class="relative h-full flex items-center justify-center px-4">
      <div
        class="w-full max-w-[520px] bg-white/5 rounded-3xl shadow-xl mx-2 backdrop-blur-xl px-6 py-8 md:px-8"
      >
        <auth-manager />
      </div>
    </div>
  </div>
</template>
